import { useEffect } from 'react';
import {
  Navigate,
  Outlet,
  useOutletContext,
  useParams,
} from 'react-router-dom';

import { Loader } from '@hivebrite/design-system/Loader';

import { useGetProgram } from 'hb-react/frontoffice/apps/Mentoring/hooks/useGetProgram';
import type { Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';

export const useMentoringOutletContext = () =>
  useOutletContext<{
    program: Program | undefined;
  }>();

const ProgramControlledAccess = () => {
  const { id = '', topicId } = useParams<{ id: string; topicId?: string }>();
  const programId = Number(id);
  const {
    data: program,
    isLoading,
    error,
  } = useGetProgram({ programId, topicId });

  useEffect(() => {
    if (error?.response?.status === 403) {
      displayXhrError(error);
    }
  }, [error]);

  if (isLoading) {
    return <Loader size={40} />;
  }

  if (error?.response?.status === 403) {
    return <Navigate to="/" />;
  }

  return <Outlet context={{ program }} />;
};

export default ProgramControlledAccess;
